import styled from "styled-components";

export const StyledImageContainer = styled.div`
display: flex;
flex-direction: row;
align-items: flex-start;
`;